// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media_hgh {
  height: 100% !important;
}

button {
  cursor: pointer;
}
.shadow-top {
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.09);
}
.navbar-radius {
  border-radius: 12px 12px 0px 0px;
}

/* STYLE BANNE */
.banner_des {
  display: none;
}

/********  CONFIG TOASTIFY STYLE ********/
.Toastify__toast-body {
  text-align: right;
  font-family: 'IranSans' !important;
}

/***** CONFIG CAROUSAL STYLE *****/
.rec-slider-container {
  width: 86% !important;
  overflow: initial !important;
}

.biYdFZ {
  overflow: visible !important;
  margin: 0 20px !important;
}

.iDBcKo {
  overflow: auto !important;
  position: inherit !important;
}

.birLPp {
  margin-top: -15px !important;
  z-index: 1;
}

.fAVBsF {
  justify-content: start !important;
}

.alice-carousel__dots {
  bottom: 25px;
  position: relative;
  margin: 0 !important;
}

@media only screen and (min-width: 300px) {
  .alice-carousel__dots {
    bottom: 25px;
  }
}

@media only screen and (min-width: 450px) {
  .alice-carousel__dots {
    bottom: 90px;
  }
}

@media only screen and (min-width: 500px) {
  .alice-carousel__dots {
    bottom: 80px;
  }
}

@media only screen and (min-width: 550px) {
  .alice-carousel__dots {
    bottom: 75px;
  }
}

@media only screen and (min-width: 600px) {
  .alice-carousel__dots {
    bottom: 72px;
  }
}

@media only screen and (min-width: 700px) {
  .alice-carousel__dots {
    bottom: 60px;
  }
}

/* DATE PICKET STYLE */
.datepicker-modal {
  background-color: rgb(0 8 195 / 30%) !important;
}

.datepicker.default .datepicker-scroll li {
  font-size: 13px;
}

.datepicker.default .datepicker-navbar-btn,
.datepicker.default .datepicker-header {
  color: #0008c3 !important;
}

.datepicker.default .datepicker-wheel {
  border-color: #0008c3 !important;
}

/********* LOADING STYLE ***********/
.bouncing-loader {
  display: flex;
  justify-content: center;
}

.bouncing-loader > div {
  width: 7px;
  height: 7px;
  margin: 3px 6px;
  border-radius: 50%;
  background-color: #fff;
  opacity: 1;
  animation: bouncing-loader 0.6s infinite alternate;
}

@keyframes bouncing-loader {
  to {
    opacity: 0.1;
    transform: translateY(-2px);
  }
}

.bouncing-loader > div:nth-child(2) {
  animation-delay: 0.2s;
}

.bouncing-loader > div:nth-child(3) {
  animation-delay: 0.4s;
}

@media screen and (min-width: 800px) {
  .media_hgh {
    height: 68% !important;
  }

  /* input.inputCheck:checked {
    border: 1px solid #fff !important;
  } */

  /* input.inputCheck:checked::before {
    background-color: #fff !important;
  } */

  .checkbox-wrapper input.inputCheck[type='checkbox'] {
    border-color: #fff !important;
  }
}

@media screen and (min-width: 895px) {
  .itm {
    width: 130px !important;
    height: 130px !important;
  }

  .fAVBsF {
    justify-content: center !important;
  }

  .banner {
    padding: 0;
  }

  .banner_des {
    display: block;
  }

  .banner_md {
    display: none;
  }

  /* BOTTOMSHEET STYLE */
  [data-rsbs-overlay],
  [data-rsbs-backdrop],
  [data-rsbs-root]:after {
    width: 30% !important;
    right: 59% !important;
  }

  [data-rsbs-is-dismissable='false'] [data-rsbs-backdrop] {
    background-color: transparent !important;
  }

  .jZpChr {
    width: 473px !important;
    height: 275px;
    overflow: initial;
    margin-top: 60px;
  }

  .rec-item-wrapper {
    width: 473px !important;
    height: 275px !important;
    overflow: initial !important;
    margin-top: 60px;
  }

  .rec-slider-container {
    /* overflow: initial !important; */
    width: 473px !important;
  }

  .banner {
    margin-top: 75px;
  }
}

@media screen and (min-width: 895px) and (max-width: 1390px) {
  .itm {
    width: 100px !important;
    height: 100px !important;
  }
}

/* For Webkit-based browsers (Chrome, Safari and Opera) */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

/* STYLE CHECKBOX COMPONET */
.span_checkbox {
  font-size: 12px;
  color: rgba(41, 45, 50, 0.5);
  margin-right: 10px;
}

.checkbox-wrapper {
}

.checkbox-wrapper input.check[type='checkbox'] {
  /* removing default appearance */
  appearance: none;
  /* creating a custom design */
  width: 13px;
  height: 13px;
  border-radius: 100%;
  margin-right: 0.5em;
  border: 1px solid rgba(0, 8, 195, 0.3);
  outline: none;
  cursor: pointer;
}

/* input.check:checked {
  position: relative;
  border: 1px solid #0008c3;
} */

/* input.check:checked::before {
  content: '';
  font-size: 1.5em;
  color: #fff;
  position: absolute;
  right: 2px;
  top: 2px;
  width: 7px;
  height: 7px;
  background: #0008c3;
  border-radius: 100%;
} */

/* STYLE BOTTOM SHEET */

[data-rsbs-overlay],
[data-rsbs-root]:after {
  background: #e6e7f9 !important;
  min-height: 350px;
}

[data-rsbs-overlay],
[data-rsbs-backdrop],
[data-rsbs-root]:after {
  border-top-left-radius: 18px !important;
  border-top-right-radius: 18px !important;
}

.is-active {
  color: #0008c3 !important;
}

.alice-carousel__dots-item:not(.__custom):hover,
.alice-carousel__dots-item:not(.__custom).__active {
  background-color: #fff !important;
}

.alice-carousel__dots-item:not(.__custom) {
  background-color: #ffffff87 !important;
}

.banner {
  margin-top: 20px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  /* button {
    cursor: none;
  } */
  /* div {
    cursor: none !important;
  } */
}

.toast_element {
  transition: all 0.3s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EAEE,YAAY;EAKZ,kBAAkB;EAClB,oBAAoB;AAJtB;;AAOA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE;IACE,YAAY;IACZ,2BAA2B;EAC7B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;KAEG;;EAEH;;KAEG;;EAEH;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA,sBAAsB;EACtB;;;IAGE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;AACA;;AAEA;EACE,gCAAgC;EAEhC,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;;;;;;;;;;;GAWG;;AAEH,uBAAuB;;AAEvB;;EAEE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;;EAGE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;;KAEG;EACH;;KAEG;AACL;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".media_hgh {\n  height: 100% !important;\n}\n\nbutton {\n  cursor: pointer;\n}\n.shadow-top {\n  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.09);\n}\n.navbar-radius {\n  border-radius: 12px 12px 0px 0px;\n}\n\n/* STYLE BANNE */\n.banner_des {\n  display: none;\n}\n\n/********  CONFIG TOASTIFY STYLE ********/\n.Toastify__toast-body {\n  text-align: right;\n  font-family: 'IranSans' !important;\n}\n\n/***** CONFIG CAROUSAL STYLE *****/\n.rec-slider-container {\n  width: 86% !important;\n  overflow: initial !important;\n}\n\n.biYdFZ {\n  overflow: visible !important;\n  margin: 0 20px !important;\n}\n\n.iDBcKo {\n  overflow: auto !important;\n  position: inherit !important;\n}\n\n.birLPp {\n  margin-top: -15px !important;\n  z-index: 1;\n}\n\n.fAVBsF {\n  justify-content: start !important;\n}\n\n.alice-carousel__dots {\n  position: relative;\n  bottom: 25px;\n  margin: 0 !important;\n}\n\n.alice-carousel__dots {\n  position: relative;\n  margin: 0 !important;\n}\n\n@media only screen and (min-width: 300px) {\n  .alice-carousel__dots {\n    bottom: 25px;\n  }\n}\n\n@media only screen and (min-width: 450px) {\n  .alice-carousel__dots {\n    bottom: 90px;\n  }\n}\n\n@media only screen and (min-width: 500px) {\n  .alice-carousel__dots {\n    bottom: 80px;\n  }\n}\n\n@media only screen and (min-width: 550px) {\n  .alice-carousel__dots {\n    bottom: 75px;\n  }\n}\n\n@media only screen and (min-width: 600px) {\n  .alice-carousel__dots {\n    bottom: 72px;\n  }\n}\n\n@media only screen and (min-width: 700px) {\n  .alice-carousel__dots {\n    bottom: 60px;\n  }\n}\n\n/* DATE PICKET STYLE */\n.datepicker-modal {\n  background-color: rgb(0 8 195 / 30%) !important;\n}\n\n.datepicker.default .datepicker-scroll li {\n  font-size: 13px;\n}\n\n.datepicker.default .datepicker-navbar-btn,\n.datepicker.default .datepicker-header {\n  color: #0008c3 !important;\n}\n\n.datepicker.default .datepicker-wheel {\n  border-color: #0008c3 !important;\n}\n\n/********* LOADING STYLE ***********/\n.bouncing-loader {\n  display: flex;\n  justify-content: center;\n}\n\n.bouncing-loader > div {\n  width: 7px;\n  height: 7px;\n  margin: 3px 6px;\n  border-radius: 50%;\n  background-color: #fff;\n  opacity: 1;\n  animation: bouncing-loader 0.6s infinite alternate;\n}\n\n@keyframes bouncing-loader {\n  to {\n    opacity: 0.1;\n    transform: translateY(-2px);\n  }\n}\n\n.bouncing-loader > div:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.bouncing-loader > div:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@media screen and (min-width: 800px) {\n  .media_hgh {\n    height: 68% !important;\n  }\n\n  /* input.inputCheck:checked {\n    border: 1px solid #fff !important;\n  } */\n\n  /* input.inputCheck:checked::before {\n    background-color: #fff !important;\n  } */\n\n  .checkbox-wrapper input.inputCheck[type='checkbox'] {\n    border-color: #fff !important;\n  }\n}\n\n@media screen and (min-width: 895px) {\n  .itm {\n    width: 130px !important;\n    height: 130px !important;\n  }\n\n  .fAVBsF {\n    justify-content: center !important;\n  }\n\n  .banner {\n    padding: 0;\n  }\n\n  .banner_des {\n    display: block;\n  }\n\n  .banner_md {\n    display: none;\n  }\n\n  /* BOTTOMSHEET STYLE */\n  [data-rsbs-overlay],\n  [data-rsbs-backdrop],\n  [data-rsbs-root]:after {\n    width: 30% !important;\n    right: 59% !important;\n  }\n\n  [data-rsbs-is-dismissable='false'] [data-rsbs-backdrop] {\n    background-color: transparent !important;\n  }\n\n  .jZpChr {\n    width: 473px !important;\n    height: 275px;\n    overflow: initial;\n    margin-top: 60px;\n  }\n\n  .rec-item-wrapper {\n    width: 473px !important;\n    height: 275px !important;\n    overflow: initial !important;\n    margin-top: 60px;\n  }\n\n  .rec-slider-container {\n    /* overflow: initial !important; */\n    width: 473px !important;\n  }\n\n  .banner {\n    margin-top: 75px;\n  }\n}\n\n@media screen and (min-width: 895px) and (max-width: 1390px) {\n  .itm {\n    width: 100px !important;\n    height: 100px !important;\n  }\n}\n\n/* For Webkit-based browsers (Chrome, Safari and Opera) */\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n/* For IE, Edge and Firefox */\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n/* STYLE CHECKBOX COMPONET */\n.span_checkbox {\n  font-size: 12px;\n  color: rgba(41, 45, 50, 0.5);\n  margin-right: 10px;\n}\n\n.checkbox-wrapper {\n}\n\n.checkbox-wrapper input.check[type='checkbox'] {\n  /* removing default appearance */\n  -webkit-appearance: none;\n  appearance: none;\n  /* creating a custom design */\n  width: 13px;\n  height: 13px;\n  border-radius: 100%;\n  margin-right: 0.5em;\n  border: 1px solid rgba(0, 8, 195, 0.3);\n  outline: none;\n  cursor: pointer;\n}\n\n/* input.check:checked {\n  position: relative;\n  border: 1px solid #0008c3;\n} */\n\n/* input.check:checked::before {\n  content: '';\n  font-size: 1.5em;\n  color: #fff;\n  position: absolute;\n  right: 2px;\n  top: 2px;\n  width: 7px;\n  height: 7px;\n  background: #0008c3;\n  border-radius: 100%;\n} */\n\n/* STYLE BOTTOM SHEET */\n\n[data-rsbs-overlay],\n[data-rsbs-root]:after {\n  background: #e6e7f9 !important;\n  min-height: 350px;\n}\n\n[data-rsbs-overlay],\n[data-rsbs-backdrop],\n[data-rsbs-root]:after {\n  border-top-left-radius: 18px !important;\n  border-top-right-radius: 18px !important;\n}\n\n.is-active {\n  color: #0008c3 !important;\n}\n\n.alice-carousel__dots-item:not(.__custom):hover,\n.alice-carousel__dots-item:not(.__custom).__active {\n  background-color: #fff !important;\n}\n\n.alice-carousel__dots-item:not(.__custom) {\n  background-color: #ffffff87 !important;\n}\n\n.banner {\n  margin-top: 20px;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 768px) {\n  /* button {\n    cursor: none;\n  } */\n  /* div {\n    cursor: none !important;\n  } */\n}\n\n.toast_element {\n  transition: all 0.3s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
